var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showAnything)?_c('h5',[_c('b-badge',{attrs:{"variant":_vm.badgeVariant}},[_vm._v(_vm._s(_vm.badgeContent))])],1):_vm._e(),(_vm.showAnything && _vm.showLower)?_c('em',[_vm._v(_vm._s(_vm.badgeLower))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }